// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SafetyCertificateOutlinedSvg from "@fishx/icons-svg/es/asn/SafetyCertificateOutlined";
import FishxIcon from '../components/FishxIcon';

var SafetyCertificateOutlined = function SafetyCertificateOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: SafetyCertificateOutlinedSvg
  }));
};

SafetyCertificateOutlined.displayName = 'SafetyCertificateOutlined';
export default React.forwardRef(SafetyCertificateOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/SafetyCertificateOutlined.js
// module id = 4054
// module chunks = 0